/**
 * @fileoverview Hand-curated cross-links for the CPA calculator related section.
 * @module components/resources/calculators/CpaCalculator.related
 * @exports {RelatedLinkEntry} RelatedLinkEntry - Glossary or sibling-tool link.
 * @exports {ReadonlyArray<RelatedLinkEntry>} RELATED_GLOSSARY - Glossary cross-links.
 * @exports {ReadonlyArray<RelatedLinkEntry>} RELATED_TOOLS - Sibling calculator links.
 */

export interface RelatedLinkEntry {
  /** Slug — for glossary: `<category>/<slug>`; for calculators: bare slug. */
  slug: string
  /** Short link text. */
  label: string
  /** One-line explanatory note rendered after the link. */
  note: string
}

export const RELATED_GLOSSARY: ReadonlyArray<RelatedLinkEntry> = [
  {
    slug: 'metrics/cost-per-acquisition-cpa',
    label: 'Cost Per Acquisition (CPA)',
    note: 'Definition, formula, and the media-only vs fully-loaded distinction.',
  },
  {
    slug: 'metrics/customer-acquisition-cost-cac',
    label: 'Customer Acquisition Cost (CAC)',
    note: 'The finance-level metric that usually sits 2–4× above platform CPA.',
  },
  {
    slug: 'metrics/return-on-ad-spend-roas',
    label: 'Return on Ad Spend (ROAS)',
    note: 'The inverse view: revenue per ad dollar instead of cost per conversion.',
  },
  {
    slug: 'metrics/cost-per-click-cpc',
    label: 'Cost Per Click (CPC)',
    note: 'The mid-funnel input: CPA = CPC ÷ conversion rate.',
  },
] as const

export const RELATED_TOOLS: ReadonlyArray<RelatedLinkEntry> = [
  {
    slug: 'roas-calculator',
    label: 'ROAS Calculator',
    note: 'Turn the same spend and revenue into return-on-ad-spend.',
  },
  {
    slug: 'customer-ltv-calculator',
    label: 'Customer LTV Calculator',
    note: 'Size the lifetime value that sets your CPA ceiling.',
  },
  {
    slug: 'cpm-calculator',
    label: 'CPM Calculator',
    note: 'Convert impression cost into the funnel that produces CPA.',
  },
  {
    slug: 'mer-calculator',
    label: 'MER Calculator',
    note: 'Check whether blended marketing efficiency still holds when CPA looks fine.',
  },
] as const
